<template>
  <VueFragment>
    <h3>{{ title }}</h3>

    <b-row style="display: flex; margin: 0;">
      <b-img
        v-for="(image, index) in images.images"
        :key="index"
        :src="require('../../assets/' + image.imageUrl)"
        :alt="image.altDescription"
        width="120"
        padding="20"
      />
    </b-row>
  </VueFragment>
</template>

<script>
import { Fragment as VueFragment } from 'vue-fragment';

export default {
  name: 'IconGrid',
  components: {
    VueFragment
  },
  props: {
    title: String,
    images: {
      type: Object,
      required: true,
      default: () => {}
    },
    imageWidth: String,
  }
}
</script>

<style lang="scss" scoped>
h3 {
  font-weight: bold;
}

img {
  padding: 20px;
}
</style>
